export const FillSavedIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 12.3624V6.84685C2.66699 4.42461 2.66699 3.21348 3.44804 2.46099C4.22909 1.7085 5.48617 1.7085 8.00033 1.7085C10.5145 1.7085 11.7716 1.7085 12.5526 2.46099C13.3337 3.21348 13.3337 4.42461 13.3337 6.84685V12.3624C13.3337 13.8996 13.3337 14.6682 12.8184 14.9433C11.8207 15.4761 9.94913 13.6986 9.06032 13.1634C8.54486 12.853 8.28712 12.6979 8.00033 12.6979C7.71353 12.6979 7.4558 12.853 6.94033 13.1634C6.05152 13.6986 4.17997 15.4761 3.18222 14.9433C2.66699 14.6682 2.66699 13.8996 2.66699 12.3624Z"
      fill="#1819B4"
      stroke="#1819B4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
